'use client'

// KawaiiIcon — the coloured dot on a stat.
//
// This used to load /icons/<name>.png and fall back to a drawn shape when
// the file was missing. None of the art was ever drawn, so every icon
// fetched a 404 and then rendered the fallback: five failed requests on the
// needs card and one on the status pill, every load, to arrive at exactly
// what you see now. Sam is happy with the dots, so the dot is the icon and
// the loading is gone.
//
// If art does turn up later, the slot is easy to put back: an <img> with an
// onError that returns this shape. Deliberately not left in place for that
// day, because a fallback that is always used is not a fallback.

export function KawaiiIcon({ color = '#f0b064', size = 26, alt = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : 'true'}
      style={{ display: 'block' }}
    >
      <circle cx="16" cy="17" r="12" fill={color} stroke="#2f2650" strokeWidth="2.5" />
      {/* The highlight is what stops it reading as a flat dot. */}
      <ellipse cx="12" cy="12.5" rx="3.4" ry="2.4" fill="rgba(255,255,255,0.55)" />
    </svg>
  )
}

export default KawaiiIcon
